module.exports = __webpack_public_path__ + "static/zoom-2-6dacf4a10339859b6a0ffe8e205f88c8.jpg";